<template>
    <!-- <div class="listing-collection-item"> -->
      <NuxtLink :to="props.src">
        <div class="listing-collection-item"
        
        >
      <div class="image-container"
      :class="{'image-container__non': !props.icon}"
      >
        <!-- <img :src='props.src' alt="Gold Rings" /> -->
        <!-- <img :src="props.icon === '' ? '../../assets/images/img_item.webp'" :alt="props.name" /> -->
        <img v-if="props.icon" :src="props.icon" :alt="props.name" />


      </div>
      <div class="collection-name">
        {{ htmlSpecialcharsDecode(props.name)}}
      </div> 
    </div>       
      </NuxtLink>


  </template>
  
  <script setup lang="ts">
  import { htmlSpecialcharsDecode } from '~/utils/helpers';
// import './style.css';
 const props = defineProps({
    src: String,
    name: String,
    icon: String
 })
  </script>
  
  <style scoped lang="scss">
  </style>
  